import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class DataService {
  private d1Subject = new BehaviorSubject<any>(this.getStoredValue('d1'));
  private d2Subject = new BehaviorSubject<any>(this.getStoredValue('d2'));
  private ufSubject = new BehaviorSubject<string>(this.getStoredValue('uf'));
  private anoSubject = new BehaviorSubject<number>(this.getStoredValue('ano') || new Date().getFullYear());
  private atualizarSubject = new BehaviorSubject<boolean>(this.getStoredValue('atualizar') || false); // Inicializa como false se não houver valor
  private dataMaxima: Date = new Date();
  private recebidoAnalitico: any = this.getStoredValue('recebidoAnalitico') || {}; // Inicializa como objeto vazio se não houver valor

  constructor(private authService: AuthService) {
    this.dataMaxima.setDate(this.dataMaxima.getDate());

    // Define valores iniciais somente se não houver dados no sessionStorage
    if (!this.getD1()) {
      this.setD1(this.dataMaxima.toLocaleDateString("pt-BR"));
    }
    if (!this.getD2()) {
      this.setD2(this.dataMaxima.toLocaleDateString("pt-BR"));
    }
    if (!this.getUF()) {
      this.setUF(this.authService.getUfUsuario());
    }
  }

  d1$ = this.d1Subject.asObservable();
  d2$ = this.d2Subject.asObservable();
  uf$ = this.ufSubject.asObservable();
  ano$ = this.anoSubject.asObservable();
  atualizar$ = this.atualizarSubject.asObservable();

  setD1(value: any) {
    const convertedValue = this.convertDateApi(value);
    this.d1Subject.next(convertedValue);
    this.storeValue('d1', convertedValue);
  }

  setD2(value: any) {
    const convertedValue = this.convertDateApi(value);
    this.d2Subject.next(convertedValue);
    this.storeValue('d2', convertedValue);
  }

  setUF(value: string) {
    const upperValue = value ? value.toUpperCase() : value;
    this.ufSubject.next(upperValue);
    this.storeValue('uf', value);
  }

  setAtualizar(value: boolean) {
    this.atualizarSubject.next(value);
    this.storeValue('atualizar', value);
  }

  setAno(value: number) {
    this.anoSubject.next(value);
    this.storeValue('ano', value);
  }

  getD1(): any {
    return this.getStoredValue('d1');
  }

  getD2(): any {
    return this.getStoredValue('d2');
  }

  getUF(): string | null {
    return this.getStoredValue('uf');
  }

  getAtualizar(): boolean {
    return this.getStoredValue('atualizar') || false; // Retorna false se não houver valor
  }

  getAno(): number {
    return this.getStoredValue('ano') || new Date().getFullYear(); // Retorna o ano atual se não houver valor
  }

  getDataMaxima(): Date {
    return this.dataMaxima;
  }

  convertDateApi(data: any): string {
    const [day, month, year] = data.split('/');
    return `${year}-${month}-${day}`;
  }


  convertDateBR(data: any): string {
    if (data != undefined) {
      const [year, month, day] = data.split('-');
      return `${day}/${month}/${year}`;
    } else {
      return null;
    }
  }


  setDados(dados: any) {
    this.recebidoAnalitico = dados;
    this.storeValue('recebidoAnalitico', dados)
  }

  getDados() {
    return this.recebidoAnalitico;
  }

  // New method to clear all data
  clearAllData(): void {
    sessionStorage.removeItem('d1');
    sessionStorage.removeItem('d2');
    sessionStorage.removeItem('uf');
    sessionStorage.removeItem('ano');
    sessionStorage.removeItem('atualizar');
    sessionStorage.removeItem('recebidoAnalitico');

    // Reset the BehaviorSubjects to their initial values
    this.d1Subject.next(null);
    this.d2Subject.next(null);
    this.ufSubject.next(null);
    this.anoSubject.next(new Date().getFullYear());
    this.atualizarSubject.next(false);
    this.recebidoAnalitico = {};
  }


  private storeValue(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  private getStoredValue(key: string): any {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }
}
